import { render, staticRenderFns } from "./McmLogo.vue?vue&type=template&id=6acea9be"
import script from "./McmLogo.vue?vue&type=script&lang=ts"
export * from "./McmLogo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports